export const STATUS_TEXT_SIZES = {
  DEFAULT: 'default',
  MICRO: 'micro',
} as const;

export type StatusTextSize =
  (typeof STATUS_TEXT_SIZES)[keyof typeof STATUS_TEXT_SIZES];

export enum StatusTextType {
  Notification,
  Info,
  Warning,
  Completed,
  Failed,
  Success,
  New,
  None,
  Price,
  White,
}
